"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trendingScenes = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case 'TRENDING':
            return action.scenes;
        default:
            return state;
    }
};
exports.popularScenes = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case 'POPULAR_THIS_WEEK':
            return action.scenes;
        default:
            return state;
    }
};
exports.featuredScenes = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case 'FEATURED':
            return action.scenes;
        default:
            return state;
    }
};
